import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/companies/page.tsx");
